import { i18n } from '@/i18n';

import {
	GET_BANNER_IN_SEARCH_LIST_REQUEST,
	GET_BANNER_IN_SEARCH_LIST_SUCCESS,
	GET_BANNER_IN_SEARCH_LIST_FAILURE,
	GET_BANNER_IN_SEARCH_REQUEST,
	GET_BANNER_IN_SEARCH_SUCCESS,
	GET_BANNER_IN_SEARCH_FAILURE,
	CREATE_BANNER_IN_SEARCH_REQUEST,
	CREATE_BANNER_IN_SEARCH_SUCCESS,
	CREATE_BANNER_IN_SEARCH_FAILURE,
	UPDATE_BANNER_IN_SEARCH_REQUEST,
	UPDATE_BANNER_IN_SEARCH_SUCCESS,
	UPDATE_BANNER_IN_SEARCH_FAILURE,
	DELETE_BANNER_IN_SEARCH_REQUEST,
	DELETE_BANNER_IN_SEARCH_SUCCESS,
	DELETE_BANNER_IN_SEARCH_FAILURE,
} from '../types';

import {
	getBannerInSearchListAPI,
	getBannerInSearchAPI,
	createBannerInSearchAPI,
	updateBannerInSearchAPI,
	deleteBannerInSearchAPI,
} from '../../services/api/bannerInSearch.api';


import {
	transformedBannerInSearchList,
	transformedBannerInSearchDetail,
	transformedBannerInSearchToApi,
} from '../../assets/js/transform/bannerInSearch';

import { transformedMeta } from '../../assets/js/transform/meta';

export default {
	namespaced: true,
	state: {
		create: {
			isCreating: false,
			isSuccess: false,
		},
		edit: {
			data: {},
			isError: false,
			isLoading: false,
			isUpdating: false,
			isDeleting: false,
		},
		list: {
			isLoading: false,
			data: [],
			meta: {},
			isError: false,
		},
	},
	getters: {},
	mutations: {
		[GET_BANNER_IN_SEARCH_REQUEST](state) {
			state.edit.isLoading = true;
			state.edit.isError = false;
		},
		[GET_BANNER_IN_SEARCH_SUCCESS](state, { data }) {
			state.edit.data = data;
			state.edit.isLoading = false;
			state.edit.isError = false;
		},
		[GET_BANNER_IN_SEARCH_FAILURE](state) {
			state.edit.isLoading = false;
			state.edit.isError = true;
		},
		[GET_BANNER_IN_SEARCH_LIST_REQUEST](state, isAppend = false) {
			state.list.isLoading = true;
			if (!isAppend) {
				state.list.data = [];
				state.list.meta = {};
			}
			state.list.isError = false;
		},
		[GET_BANNER_IN_SEARCH_LIST_SUCCESS](state, { data = [], meta = {}, isAppend = false }) {
			state.list.isLoading = false;
			state.list.isError = false;
			const transformedData = transformedBannerInSearchList(data);
			state.list.data = isAppend
				? [...state.list.data, ...transformedData]
				: transformedData;
			state.list.meta = transformedMeta(meta);
		},
		[GET_BANNER_IN_SEARCH_LIST_FAILURE](state) {
			state.list.data = [];
			state.list.meta = {
				total: 0,
				lastPage: 1,
				currentPage: 1,
			};
			state.list.isLoading = false;
			state.list.isError = true;
		},
		[CREATE_BANNER_IN_SEARCH_REQUEST](state) {
			state.create.isCreating = true;
			state.create.isSuccess = false;
		},
		[CREATE_BANNER_IN_SEARCH_SUCCESS](state) {
			state.create.isCreating = false;
			state.create.isSuccess = true;
		},
		[CREATE_BANNER_IN_SEARCH_FAILURE](state) {
			state.create.isCreating = false;
			state.create.isSuccess = false;
		},
		[UPDATE_BANNER_IN_SEARCH_REQUEST](state) {
			state.edit.isUpdating = true;
		},
		[UPDATE_BANNER_IN_SEARCH_SUCCESS](state) {
			state.edit.isUpdating = false;
		},
		[UPDATE_BANNER_IN_SEARCH_FAILURE](state) {
			state.edit.isUpdating = false;
		},
		[DELETE_BANNER_IN_SEARCH_REQUEST](state) {
			state.edit.isDeleting = true;
		},
		[DELETE_BANNER_IN_SEARCH_SUCCESS](state) {
			state.edit.isDeleting = false;
		},
		[DELETE_BANNER_IN_SEARCH_FAILURE](state) {
			state.edit.isDeleting = false;
		},
	},
	actions: {
		/**
		* Get banner in search list
		* @param {Object} params { page, platform, content_type }
		* @return {Array} array of banner in search
		*/
		async getBannerInSearches({ commit }, params) {
			try {
				commit(GET_BANNER_IN_SEARCH_LIST_REQUEST, params.isAppend);
				const { data } = await getBannerInSearchListAPI(params);
				commit(GET_BANNER_IN_SEARCH_LIST_SUCCESS, {
					data: data.data,
					meta: data.meta,
					isAppend: params.isAppend,
				});
			} catch (error) {
				commit(GET_BANNER_IN_SEARCH_LIST_FAILURE);
			}
		},
		async getBannerInSearch({ commit }, id) {
			try {
				commit(GET_BANNER_IN_SEARCH_REQUEST);
				const { data } = await getBannerInSearchAPI(id);
				const transformedData = transformedBannerInSearchDetail(data.data);
				commit(GET_BANNER_IN_SEARCH_SUCCESS, { data: transformedData });
			} catch (error) {
				commit(GET_BANNER_IN_SEARCH_FAILURE);
			}
		},
		async createBannerInSearch({ commit, dispatch }, params) {
			try {
				const body = transformedBannerInSearchToApi(params);
				commit(CREATE_BANNER_IN_SEARCH_REQUEST);
				await createBannerInSearchAPI(body);
				commit(CREATE_BANNER_IN_SEARCH_SUCCESS);
				dispatch(
					'toast/showCreateSuccessToast',
					i18n.t('page.bannerInSearch.title'),
					{ root: true },
				);
			} catch (error) {
				commit(CREATE_BANNER_IN_SEARCH_FAILURE);
				dispatch('toast/showCreateErrorToast', error, { root: true });
				throw error;
			}
		},
		async updateBannerInSearch({ commit, dispatch }, params) {
			try {
				const body = transformedBannerInSearchToApi(params);
				commit(UPDATE_BANNER_IN_SEARCH_REQUEST);
				await updateBannerInSearchAPI(params.id, body);
				commit(UPDATE_BANNER_IN_SEARCH_SUCCESS);
				dispatch('toast/showUpdateSuccessToast', null, { root: true });
			} catch (error) {
				commit(UPDATE_BANNER_IN_SEARCH_FAILURE);
				dispatch('toast/showCreateErrorToast', error, { root: true });
				throw error;
			}
		},
		async deleteBannerInSearch({ commit, dispatch }, id) {
			try {
				commit(DELETE_BANNER_IN_SEARCH_REQUEST);
				await deleteBannerInSearchAPI(id);
				commit(DELETE_BANNER_IN_SEARCH_SUCCESS);
				dispatch(
					'toast/showDeleteSuccessToast',
					i18n.t('page.bannerInSearch.title'),
					{ root: true },
				);
			} catch (error) {
				commit(DELETE_BANNER_IN_SEARCH_FAILURE);
				dispatch('toast/showDeleteErrorToast', error, { root: true });
				throw error;
			}
		},
	},
};
